import React from 'react';
import { Input } from 'antd';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane } from '@fortawesome/pro-light-svg-icons';
import {Box, Flex} from "../../../shared/components";

interface NotasInputProps{
  addNote: any,
  handleChange: any,
  notaText: string,
  emptyError: boolean,
  disabled: boolean
}

export default function NotasInput({addNote, handleChange, notaText, emptyError, disabled}:NotasInputProps){

  return(
    <Input
      placeholder="Escriba aquí..."
      disabled={disabled}
      addonAfter={(
        <Flex
          style={{ width: '100%', height: '100%' }}
          className="sendNote"
          justifyContent="center"
          onClick={addNote}
          alignItems="center"
        >
          <FontAwesomeIcon icon={faPaperPlane} />
        </Flex>
    )}
      onChange={handleChange}
      style={{ width: '100%' }}
      name="notas"
      onPressEnter={addNote}
      value={notaText}
      className={emptyError ? 'input-note-border-error' : ''}
    />
  )
}
